import {inject, Injectable} from '@angular/core';

import {TerminalManagerService} from '@core/services/terminal-manager/terminal-manager.service';
import {PaymentGateway, PaymentMethod} from '@features/payment/domain/model/payment.model';
import {
  PaymentGatewayResolution,
  PaymentGatewayResolver,
} from '@features/payment/domain/ports/resolver/payment-gateway-resolver.port';

@Injectable({providedIn: 'root'})
export class DefaultPaymentGatewayResolver implements PaymentGatewayResolver {
  private readonly terminalManager = inject(TerminalManagerService);

  resolve(method: PaymentMethod): PaymentGatewayResolution {
    if (method === PaymentMethod.CASH) {
      return {gateway: PaymentGateway.CUSTOMER};
    }

    if (method === PaymentMethod.WALLET) {
      return {gateway: PaymentGateway.WALLET};
    }

    if (method === PaymentMethod.COMPLEMENT || method === PaymentMethod.CONSUMPTION) {
      return {gateway: PaymentGateway.API};
    }

    if (method === PaymentMethod.CARD && this.terminalManager.currentTerminal) {
      return {gateway: PaymentGateway.TERMINAL, sourceId: this.getTerminalSourceId()};
    }

    if (method === PaymentMethod.CARD && this.terminalManager.isTap2PayEnabled) {
      return {gateway: PaymentGateway.TAP_TO_PAY};
    }

    return {gateway: PaymentGateway.CUSTOMER};
  }

  private getTerminalSourceId(): string {
    return (this.terminalManager.currentTerminal?.poiid ?? '').trim();
  }
}
